exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main__main___wmLku {\n  width: 90vw;\n  margin: 0 auto; }\n  .main__main___wmLku header {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 70px; }\n  .main__main___wmLku .main__sidebarChat___3qaec {\n    height: calc(100vh - 140px);\n    display: flex;\n    margin-top: 20px; }\n", ""]);

// exports
exports.locals = {
	"main": "main__main___wmLku",
	"sidebarChat": "main__sidebarChat___3qaec"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/containers/Main/main.scss
// module id = 899
// module chunks = 0